/** Same token shape as backend SlashInvocation. */
export const SKILL_SLASH_TOKEN_RE = /(?<![\w/])\/([a-z0-9]+(?:-[a-z0-9]+)*)/gi

export function hasSkillSlashToken(text: string, slug: string): boolean {
  const re = new RegExp(`(?<![\\w/])/${slug.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(?![\\w-])`, "i")
  return re.test(text)
}
